import {
	AnyCondition,
	WebAPIItemBase,
} from '@/globals/webApiTypes/elements/WebAPIDecisionToolData';
import {
	AnyRenderedQuestion,
	GivenAnswers,
} from '../_questions/question.types';
import { getConditionMethods } from '../_questions/getQuestionMethods';
import { assertNever } from '@/globals/helpers/assert.helpers';

const matchCondition = ({
	condition,
	givenAnswers,
	relevantQuestions,
}: {
	condition: AnyCondition;
	givenAnswers: GivenAnswers;
	relevantQuestions: Array<AnyRenderedQuestion>;
}) => {
	const question = relevantQuestions.find((q) => q.id === condition.questionId);
	if (question == null) return false;
	const { isMatch } = getConditionMethods(question.type);
	const match = isMatch({ condition, givenAnswers });

	return match;
};

export const matchConditions = ({
	givenAnswers,
	allQuestions,
	relevantQuestions,
	item,
}: {
	givenAnswers: GivenAnswers;
	allQuestions: Array<AnyRenderedQuestion>;
	relevantQuestions: Array<AnyRenderedQuestion>;
	item: Pick<WebAPIItemBase, 'includedBy' | 'includedWhen'>;
}) => {
	const conditions = item.includedBy.filter((condition) => {
		const question = allQuestions.find((q) => q.id === condition.questionId);
		if (question == null) return false;
		const { isValid } = getConditionMethods(question.type);

		return isValid(condition);
	});

	if (conditions.length === 0) return true;

	const includedWhen = item.includedWhen;

	switch (includedWhen) {
		case 'everyQuestionMatches':
			return conditions.every((condition) =>
				matchCondition({ condition, givenAnswers, relevantQuestions }),
			);
		case 'someQuestionsMatch':
			return conditions.some((condition) =>
				matchCondition({ condition, givenAnswers, relevantQuestions }),
			);
		default:
			return assertNever(includedWhen);
	}
};
